import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScCopyright = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin-top: 64px;

  & > .license-link {
    width: 60px;
  }

  & > .copyright {
    flex: 1;
    max-width: 1480px;
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.secondaryColor};
    text-align: center;
  }

  @media (${device.mobile}) {
    flex-wrap: wrap;
    flex-direction: column;

    & > .copyright {
      width: 100%;
      text-align: center;
    }
  }
`;
